import * as r from "react";
import a from "../lib/SSRBase.es.js";
import f from "../defs/ArrowLeft.es.js";
const o = r.forwardRef((e, t) => /* @__PURE__ */ r.createElement(a, { ref: t, ...e, weights: f }));
o.displayName = "ArrowLeftIcon";
const c = o;
export {
  c as ArrowLeft,
  o as ArrowLeftIcon
};
